import { useState, useEffect } from "react";

const Pagination = ({ totalPages, onPageChange, currentPage }) => {
    return (
        <nav aria-label="Page navigation">
            <ul className="list-inline">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page} className="list-inline-item">
                        <button
                            className={`btn ${currentPage === page ? 'u-btn-primary' : 'u-btn-outline-primary'} g-rounded-50 g-px-15 g-py-6 g-font-size-13`}
                            onClick={() => onPageChange(page)}
                        >
                            {page}
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Pagination;